import React, { useState, useEffect, useMemo } from "react";
import {  message, Popconfirm } from "antd";
import Chart from "react-apexcharts";
import moment from "moment";
import { HiArrowDownTray } from "react-icons/hi2";
import { ArrowLeftOutlined, EditOutlined, SearchOutlined, DownloadOutlined, PlusOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import server, { endpoints } from "../../../utils/server.js";
import { rootEndpoint } from "../../../utils/constants.js";
import TutoringTable from "../../../components/Tutoring/tutoringTable.jsx";
import StatsCarousel from "../../../components/Tutoring/statsCarousel.jsx";
import TutoringModal from "../../../components/Tutoring/tutoringModal.jsx";
import Button from "../../../components/General/button.jsx";
import "./style/tutoringStyle.scss";




const Tutoring = ({ idCycle, id_UR, session, userTeams,permisoTutoring }) => {

  const [openModal, setOpenModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);

  const [filteredUserIds, setFilteredUserIds] = useState([]);

  //________Datos Tabla_________________
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const [total, setTotal] = useState(0);
  const [teams, setTeams] = useState([]);
  const [masterData, setMasterData] = useState([]); 
  const [tutorName, setTutorName] = useState(""); 
  const [actualPeriod, setActualPeriod] = useState(); 

  const [allUsers, setAllUsers] = useState();

  const [sort, setSort] = useState({ key: "id", direction: "asc" });
  const [filters, setFilters] = useState({});
  const [isFiltered, setIsFiltered] = useState(false);

  const [isReportView, setIsReportView] = useState(false); 
  const [selectedRowData, setSelectedRowData] = useState(null);

  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    const isSecondSemester = idCycle % 2 !== 0;
  
  const baseData = isSecondSemester ? [
    { value: "", label: "Todos los periodos" },
    { value: "07", label: "Jul" },
    { value: "08", label: "Ago"},
    { value: "09", label: "Sep"},
    { value: "10", label: "Oct"},
    { value: "11", label: "Nov"},
    { value: "12", label: "Dic"},
  ] : [
    { value: "", label: "Todos los periodos" },
    { value: "01", label: "Ene"},
    { value: "02", label: "Feb"},
    { value: "03", label: "Mar"},
    { value: "04", label: "Abr"},
    { value: "05", label: "May"},
    { value: "06", label: "Jun"},
  ];
  setActualPeriod(baseData);
    getTeamsInCycle();
    getAllUsersInCycleWithTeams(); 
  if(permisoTutoring){
getTutoringPerCycle();
  }else{
   getTutoringPerTutor();
  }
  
  }, [idCycle, permisoTutoring,openModal]); 

   useEffect(() => {
    // Si no ha escrito nada en el filtro, ignoramos
    if (filters.asesor === undefined) return;

    const delayDebounceFn = setTimeout(() => {

      const currentVal = filters.asesor;
      const searchText = (currentVal && String(currentVal)!== "") 
        ? String(currentVal)
        : "";
      if (permisoTutoring) {
        getTutoringPerCycle(searchText);
        setPage(1); // Reiniciamos a la primera página cuando cambia el filtro del servidor
      }
    }, 400);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.asesor, idCycle, permisoTutoring]);

  useEffect(() => {
    // Determina si hay algún filtro con valor activo
    const hasActiveFilters = Object.values(filters).some(
      (val) => val !== undefined && val !== "" && val !== null
    );
    setIsFiltered(hasActiveFilters);
  }, [filters]);

useEffect(() => {
    if (masterData.length === 0) {
      setData([]);
      setTotal(0);
      return;
    }

    setLoading(true);
    let processedData =[...masterData];

    // --- A. FILTROS ---
    if (filters.equipo) {
      if (isReportView) {
        processedData = processedData.filter((item) => item.equipo === filters.equipo);
        setData(processedData);

      } else {
        processedData = processedData.filter((item) =>
          item.equipo?.toLowerCase().includes(filters.equipo.toLowerCase())
        );
      }
    }
if (filters.asesorado) {
      const searchText = filters.asesorado.toLowerCase();
      processedData = processedData.filter((item) =>
        item.asesorado?.toLowerCase().includes(searchText)
      );
    }

    if (filters.periodo) {
      processedData = processedData.filter((item) => {
        if (!item.fecha) return false;

        const mesDeLaFecha = item.fecha.split("-")[1]; 

        const filtroMes = String(filters.periodo).padStart(2, '0');

        return mesDeLaFecha === filtroMes;
      });
      setData(processedData);
    }

    // --- B. ORDENAMIENTO ---
    if (sort.key) {
      processedData.sort((a, b) => {
        let valA = a[sort.key];
        let valB = b[sort.key];

        if (valA === null || valA === undefined) valA = "";
        if (valB === null || valB === undefined) valB = "";

        if (typeof valA === "number" && typeof valB === "number") {
          return sort.direction === "asc" ? valA - valB : valB - valA;
        }

        const strA = String(valA).toLowerCase();
        const strB = String(valB).toLowerCase();

        return sort.direction === "asc"
          ? strA.localeCompare(strB)
          : strB.localeCompare(strA);
      });
    }

    const idsUnicos = Array.from(
        new Set(processedData.map((item) => item.id_tutored_user).filter(Boolean))
    );
    setFilteredUserIds(idsUnicos);

    setTotal(processedData.length);
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    
    setData(processedData.slice(startIndex, endIndex));
    setLoading(false);

  }, [masterData, page, pageSize, sort, filters, isReportView]);

  useEffect(() => {
    if (isReportView) {
      setPageSize(5);
      setPage(1);
    } else {
      setPageSize(10);
    }
  }, [isReportView]);

  useEffect(()=>{
    const now = new Date();
    const currentMonth = now.getMonth() + 1; 
    const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;
    if(masterData){

    const statsMap = {};
    masterData.forEach(item => {
        // Validamos que tenga equipo y fecha
        if (!item.equipo || !item.fecha) return;
        
        const team = item.equipo;
        const monto = Number(item.duracion) || 0; 

        if (!statsMap[team]) {
            statsMap[team] = { 
                totalSum: 0, 
                currentMonthSum: 0, 
                prevMonthSum: 0 
            };
        }

        statsMap[team].totalSum += monto;

        const mesItem = parseInt(item.fecha.split("-")[1], 10);
        
        if (mesItem === currentMonth) {
            statsMap[team].currentMonthSum += monto;
        } else if (mesItem === prevMonth) {
            statsMap[team].prevMonthSum += monto;
        }
    });

    const newCardData = Object.keys(statsMap).map(teamName => {
  
        const stats = statsMap[teamName];
        
        // Lógica de tendencia: Si mes actual >= mes anterior -> 'up', sino 'down'
        const trend = stats.currentMonthSum >= stats.prevMonthSum ? 'up' : 'down';

        return {
            titulo: teamName,
            total: (stats.totalSum<60?`${stats.totalSum} min`:`${Math.trunc(stats.totalSum/60)} hrs ${stats.totalSum%60} min`), 
            mensual: (stats.totalSum<60?`${stats.totalSum} min`:`${Math.trunc(stats.totalSum/60)} hrs ${stats.totalSum%60} min`),
            tendenciaMensual: trend,
            tendenciaSemanal: 'up' 
        };
    });
    setCardData(newCardData);
  }
  },[masterData])

  const chartData = useMemo(() => {
  const isSecondSemester = idCycle % 2 !== 0;
  
  const baseData = isSecondSemester ? [
    { name: 'Jul', number: "07", cant: 0 },
    { name: 'Ago', number: "08", cant: 0 },
    { name: 'Sep', number: "09", cant: 0 },
    { name: 'Oct', number: "10", cant: 0 },
    { name: 'Nov', number: "11", cant: 0 },
    { name: 'Dic', number: "12", cant: 0 },
  ] : [
    { name: 'Ene', number: "01", cant: 0 },
    { name: 'Feb', number: "02", cant: 0 },
    { name: 'Mar', number: "03", cant: 0 },
    { name: 'Abr', number: "04", cant: 0 },
    { name: 'May', number: "05", cant: 0 },
    { name: 'Jun', number: "06", cant: 0 },
  ];

  const dataMap = {};
  baseData.forEach(item => {
    dataMap[item.number] = item;
  });

  // Condicional para mostrar data (filtrada) o masterData (completa)
  const dataSource = isFiltered ? (data || []) : (masterData || []);

  dataSource.forEach((item) => {
    if (!item.fecha) return;
    const arr = item.fecha.split("-");
    const mes = arr[1]; 
    if (dataMap[mes]) {
      dataMap[mes].cant += 1;
    }
  });

  return baseData;
}, [idCycle, data, masterData, isFiltered]);

     const getTutoringPerCycle = async (searchText = "") => {
    const res = await server(
      endpoints.getTutoringPerCycle.route,
      endpoints.getTutoringPerCycle.method,
      { id_cycle: idCycle, id_user: id_UR },
      searchText=="" ? null : 
      { tutor_name: searchText } 
    );
    
    if (res.error_message) { 
         message.error(res.error_message || "Error al cargar datos");
    } else {
         const formattedData = (res.data.tutorings ||[]).map(item => ({
            id: item.id,        
            fecha: item.date.split("T")[0],            
            tema: item.title || "Sin tema",
            asesor: item.tutor_name,
            asesorado: item.name,
            equipo: item.team_name,      
            periodo: item.period_number,  
            duracion: item.amount*15 ,
            id_tutored_user: item.id_tutored_user
         }));

         setMasterData(formattedData);
         setTotal(formattedData.length); 
    }
  };

      const getTutoringPerTutor = async () => {
      const res = await server(
        endpoints.getTutoringPerTutor.route,
        endpoints.getTutoringPerTutor.method,
        { id_cycle: idCycle,
          id_user: id_UR }
      );
     
      if (res.error_message) { 
           message.error(res.error_message || "Error al cargar datos");
        } else {
           const formattedData = (res.data.tutoringsPerTutor || []).map(item => ({      
              id: item.id,        
            fecha: item.date,            
            tema: item.tutoring_title || "Sin tema",
            asesor: item.tutoring_name,
            asesorado: item.tutored_name,
            equipo: item.team,      
            periodo: item.period_number,  
            duracion: item.amount*15 
           }));

           setMasterData(formattedData); 
           setTotal(formattedData.length); 
    }
  };

  const getTeamsInCycle = async () => {
      const res = await server(
        endpoints.getTeamsInCycle.route,
        endpoints.getTeamsInCycle.method,
        { id_cycle: idCycle}
      );
     
      if (res.error_message) { 
           message.error(res.error_message || "Error al cargar datos");
        } else {
           
           const formattedData =[ 
            { value: "", label: "Todos los equipos" }, 
            ...(res.data || []).map(item => ({      
              value: item.name,
              label: item.name
           }))
          ];

           setTeams(formattedData); 
    }
  };

    const getAllUsersInCycleWithTeams = async () => {
      const res = await server(
        endpoints.getAllUsersInCycleWithTeams.route,
        endpoints.getAllUsersInCycleWithTeams.method,
        { id_cycle: idCycle}
      );
     
      if (res.error_message) { 
           message.error(res.error_message || "Error al cargar datos");
        } else {
           
          setAllUsers(res.data); 
    }
  };

  const getTutoringExcel = async () => {
    if (filteredUserIds.length === 0) {
       message.warning("No hay datos para exportar con los filtros actuales.");
       return;
    }

    const queryString = new URLSearchParams({
      id_cycle: idCycle,
      id_user: id_UR,
      id_team: !permisoTutoring? 8:null,
    },{
      id_tutor:filteredUserIds.join(","),
      team:filteredUserIds.join(","),
      id_tutor:filteredUserIds.join(",")
    }).toString();
    var url = ``;

    url = `${rootEndpoint()}api/${
      endpoints.getTutoringExcel.route
    }/?${queryString}`;

    try {
      window.location.href = url;
    } catch (error) {
      console.error("Error al obtener la URL de Excel:", error);
      return null;
    }
  };

  const getBadgeClass = (equipo) => {
    switch (equipo) {
      case "Sistemas": case "TH": return "badge--green";
      case "Coro": return "badge--yellow";
      case "Instrumentos": return "badge--blue";
      case "COMMER": return "badge--pink";
      default: return "badge--gray";
    }
  };
const tutorOptions = useMemo(() => {
  const base = [{ value: "", label: "Todos los asesores" }];
  if (!allUsers) return base;

  const seenIds = new Set();
  const uniqueTutors = [];

  // Eliminamos duplicados por ID antes de generar las opciones
  allUsers.forEach((user) => {
    const fullName = `${user.first_name} ${user.last_name}`;
    if (!seenIds.has(fullName)) {
      seenIds.add(fullName);
      
      uniqueTutors.push({
        value: fullName, 
        label: fullName,
      });
    }
  });

  return [...base, ...uniqueTutors];
}, [allUsers]);

const columns = useMemo(() => [
    { 
      key: "fecha", 
      header: "Fecha", 
      sortable: true,
      render: (row) => moment(row.fecha).format('YYYY-MM-DD'),
      filter: isReportView ? {
        type: "select",
        name: "periodo",
        label: "Periodo",
        options: actualPeriod
      } : null 
    },
    { 
      key: "tema", 
      header: "Tema", 
      sortable: true, 
      
    },
    { 
      key: "asesor", 
      header: "Asesor",
      sortable: true,
      render: (row) => <span title={row.asesor} className="text-truncate">{row.asesor}</span>,
      filter: permisoTutoring ?{
        type: "select",
        name: "asesor",
        label: "Asesor",
        options: tutorOptions
      }:null
    },
    { 
      key: "asesorado", 
      header: "Asesorado", 
      sortable: true, 
      render: (row) => <span title={row.asesorado} className="text-truncate">{row.asesorado}</span>,
      filter: !permisoTutoring ?{ type: "text", placeholder: "Buscar asesorado..." }:null,
    },
    {
      key: "equipo",
      header: "Equipo",
      sortable: true,
      render: (row) => <span className={`table-badge ${getBadgeClass(row.equipo)}`}>{row.equipo}</span>,
      filter: isReportView ? {
        type: "select",
        options: teams
      } : null,
    },
    { 
      key: "duracion", 
      header: "Duración", 
      sortable: true,
      width: "80px", 
      render: (r) => <div className="text-center">{r.duracion} min</div> 
    },
    {
      key: "actions", 
      header: "", 
      width: "50px",
      sortable: false, 
      render: (row) =>( 
      <div className="action-cell">
        <EditOutlined
         className="icon-edit"
         onClick={()=>{
          setSelectedRowData(row);
          setUpdateModal(true);
          setOpenModal(true);}}/>
         </div>)
    },
  ], [isReportView,permisoTutoring,tutorOptions]);


  // Configuración del Gráfico
  const chartConfig = {
    series: [{
      name: 'Asesorías',
      data: chartData.map(d => d.cant) 
    }],
    options: {
      chart: {
        type: 'bar',
        toolbar: { show: false }, // Oculta menú hamburguesa del gráfic
        fontFamily: 'inherit'
      },
      colors: [
        function({ value, seriesIndex, dataPointIndex, w }) {
 
const maxCant = Math.max(...chartData.map(item => item.cant));

  return value === maxCant ? '#0096ff' : '#dbeafe';
        }
      ],
      plotOptions: {
        bar: {
          borderRadius: 8,      
          borderRadiusApplication: 'end', 
          columnWidth: '45%',   
          distributed: true,   
          dataLabels: {
            position: 'top',     
          },
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ["#333"]
        }
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: chartData.map(d => d.name), 
        axisBorder: { show: true, color: '#000' }, 
        axisTicks: { show: false },
        labels: {
          style: {
            fontSize: '12px',
            colors: '#333'
          }
        }
      },
      yaxis: {
        show: false,
      },
      grid: {
        show: false, 
      },
      tooltip: {
        enabled: true,
      }
    }
  };


  const summaryActions = (
    <div className="table-actions-group">
{permisoTutoring && (
      <Button
      type={"default secondary"}
        icon={<HiArrowDownTray />}
        onClickAction={()=>{getTutoringExcel()}}
      />
)}
      <Button onClickAction={()=>{setUpdateModal(false); setOpenModal(true);}} text="Agregar" icon={<PlusOutlined />} />
    </div>
  );

  return (
    <div className="container-Advisory">
      <div className="header-asesorias">
        <div className="btn-back">
          {!isReportView?
          <NavLink to="events">
            <Button icon={<ArrowLeftOutlined />} text="Regresar" type={"default secondary"}/>
          </NavLink>:
          <Button icon={<ArrowLeftOutlined />}
          onClickAction={()=>{setIsReportView(false)}} 
          text="Regresar"
          type={"default secondary"}/>
        }
        </div>
        <h1 style={{ margin: 0, textAlign: "center" }}>Asesorias {session.full_name}</h1>
        <div />
      </div>
      {!permisoTutoring && (
        <>

          <div className="summary-table-container">
             <TutoringTable
                columns={columns}
                 data={data || []}
                sort={sort}
                onSortChange={setSort}
                filters={filters}
                onFilterChange={setFilters}
                page={page}
                pageSize={pageSize}
                total={total}
                onPageChange={setPage}
                loading={loading}
            
                actions={summaryActions} 
                className="custom-table-look table-summary-view" 
             />
          </div>
        </>
      )}
      {!isReportView && permisoTutoring && (
        <>
          <div className="tutoring-carrousel">
             <StatsCarousel cardData={cardData} /> 
          </div>
<a className="tutoring-report" onClick={() => setIsReportView(true)}>
               Ver reporte completo &gt;
             </a>

          <div className="summary-table-container">
             <TutoringTable
                columns={columns}
                data={data || []}
                sort={sort}
                onSortChange={setSort}
                filters={filters}
                onFilterChange={setFilters}
                page={page}
                pageSize={pageSize}
                total={total}
                onPageChange={setPage}
                loading={loading}
                
                actions={summaryActions} 
                className="custom-table-look table-summary-view" 
             />
          </div>
        </>
      )}

     {isReportView &&  permisoTutoring&&(
        <div className="report-container fade-in">
          
          <div className="report-grid-layout">
            
            <div className="report-left-col">
               <TutoringTable
                columns={columns}
                data={data || []}
                sort={sort}
                onSortChange={setSort}
                filters={filters}
                onFilterChange={(newFilters) => {
                    setFilters(newFilters);
                    setPage(1);
                }}
                page={page}
                pageSize={pageSize}
                total={total}
                onPageChange={setPage}
                loading={loading}
                className="custom-table-look"
              />
            </div>

            <div className="report-right-col">
               
               <div className="report-actions-header">
                  
                  <Button onClickAction={()=>{getTutoringExcel()}} type={"default secondary"} icon={<HiArrowDownTray />} />
                  <Button onClickAction={()=>{setUpdateModal(false); setOpenModal(true);}} text="Agregar" icon={<PlusOutlined/>} />
               </div>

               <div className="report-chart-card">
                  <h3>Número de Asesorías</h3>
                  <div className="chart-wrapper">
                    <Chart 
                        options={chartConfig.options} 
                        series={chartConfig.series} 
                        type="bar" 
                        height={300} 
                        width="100%"
                    />
                  </div>
               </div>

            </div>
          </div>
        </div>
      )}

      {openModal && 
      <TutoringModal
       idCycle={idCycle} 
       id_UR={id_UR}
        session={session} 
        updating={updateModal} 

         infoTutoring={selectedRowData} 
        onClose={()=>setOpenModal(false)}
        ></TutoringModal>}

    </div>
  );
};

export default Tutoring;
